// extracted by mini-css-extract-plugin
export default {"button":"styles_button__QfI0W","menuTitle":"styles_menuTitle__YKG6t","title":"styles_title__svqyh"};